globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.LocalManagement = appCustomerSpace.Modals.LocalManagement || {};

appCustomerSpace.Modals.LocalManagement.ServiceItems = (function(superClass) {

  utils.extend(ServiceItems, superClass);

  function ServiceItems() {
    return ServiceItems.__super__.constructor.apply(this, arguments);
  }

  $.extend(ServiceItems.prototype, {
    init: function() {
      this.initFormEvents();
      return ServiceItems.__super__.init.apply(this, arguments);
    },
    open: function(){
      appCustomerSpace.Modules.InputCharactersCount.init(this.$html)
      return ServiceItems.__super__.open.apply(this, arguments);
    },
    initFormEvents: function(){
      var modal = this;

      modal.$html
      .on('click', '.structured-service-item .form-control', function(){
        var $checkbox = $(this).closest('.structured-service-item').find('input.checkbox-selection');
        $checkbox.prop('checked', !$checkbox.is(':checked')).trigger('change').uniform();

      }).on('change', 'input.checkbox-selection', function(){
        modal.refreshDestroyState($(this).closest('.service-item'));

      });
    },
    refreshDestroyState: function($serviceItem) {
      $serviceItem.find('input.destroy').val(!$serviceItem.find('input.checkbox-selection').is(':checked'));
    },
    callbackSuccess: function(data, successMsg) {
      if (data == null) {
        data = {};
      }

      if (data.response) {
        this.updateView(data);
        this.close();
      } else {
        appCustomerSpace.Loader().stop();
        $.each(data.errors, function(key, value) {
          var $error = $('<p class="text-danger">' + value[0] + '</p>');

          if(/description/.test(key)) {
            var $input = $('.service-item-description-input');
          }

          if(/name/.test(key)) {
            var $input = $('.service-item-name-input');
          }

          $error.appendTo($input);
          $input.addClass('has-error');
        });
      }
    },
    updateView: function(data) {
      var $thumbnail = $(data.views.thumbnail),
          id = $thumbnail.data('activity-id'),
          $currentThumbnail = $('.business-activity-service-items[data-activity-id='+id+']');

      $currentThumbnail.replaceWith($thumbnail);
      appCustomerSpace.LimitlessPlugins.initPlugins($('.business-activity-service-items[data-activity-id='+id+']'));
    }
  });

  return ServiceItems;

})(appCustomerSpace.Modal);
